import { makeStyles, Theme } from "@material-ui/core/styles";
import COLORS from "common/Theme/colors";

export const useStyles = makeStyles((theme: Theme) => ({
  profileDetailContainer: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "space-around",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
    },
  },
  profileSubContainer: {
    display: "flex",
    [theme.breakpoints.down("md")]: {
      width: "100%",
      marginBottom: 8,
    },
  },
  headingText: {
    fontSize: "14px",
    lineHeight: "20px",
    color: COLORS.MINE_SHAFT,
  },
  headingSubText: {
    fontSize: "16px",
    lineHeight: "20px",
    color: COLORS.BLACK,
    fontWeight: 700,
  },
  styledButton: {
    color: theme.palette.primary.main,
    borderColor: theme.palette.primary.main,
    fontSize: "14px",
    lineHeight: "20px",
    fontWeight: 700,
    borderRadius: 4,
  },
  normalText: {
    fontSize: "14px",
    lineHeight: "20px",
  },
  dangerText: {
    fontSize: "14px",
    lineHeight: "20px",
    color: theme.palette.secondary.main,
  },
  notification:{
    position:'absolute',
    left:'40%',
    top:'8%',
    zIndex:1
  }
}));
